import React, { KeyboardEvent, useState } from 'react';
import TextField, { TextFieldProps } from '@mui/material/TextField';

export type NumberFieldProps = TextFieldProps & {
  value: number;
  min?: number;
  max?: number;
  label?: string;
  wholeNumbersOnly?: boolean;
  onValueChange: (value: number) => void; //* This handler is triggered only by the onBlur event.
};

export function NumberField(props: NumberFieldProps) {
  const { min, max, wholeNumbersOnly, ...rest } = props;
  const [value, setValue] = useState<number | string>(props.value ?? ''); //* Empty the field if value's not set instead of showing 0.

  const handleBlur = () => {
    let parsedValue: number = +value;
    if (min !== undefined && parsedValue < min) {
      parsedValue = min;
    }
    if (max !== undefined && parsedValue > max) {
      parsedValue = max;
    }
    if (wholeNumbersOnly) {
      parsedValue = Math.round(parsedValue);
    }
    setValue(parsedValue);
    props.onValueChange(parsedValue);
  };

  const handleKeyDown = (event: KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      (event.target as HTMLInputElement).blur();
      handleBlur();
    }
  };

  return (
    <TextField
      {...rest}
      type="number"
      variant="standard"
      size="small"
      InputProps={{
        ...props.InputProps,
        inputProps: {
          min,
          max,
          'data-testid': 'number-field-input',
          sx: { paddingTop: '4px' }
        }
      }}
      value={value}
      onChange={(e) => setValue(e.target.value)}
      onBlur={handleBlur}
      onKeyDown={handleKeyDown}
    />
  );
}
